/** FormField — label + hint/error wrapper around any control. */
import { type ReactNode } from 'react'
import { cn } from '@/lib/cn'

interface FormFieldProps {
  label: string
  htmlFor?: string
  hint?: string
  error?: string
  children: ReactNode
  className?: string
}

export function FormField({
  label, htmlFor, hint, error, children, className,
}: FormFieldProps) {
  return (
    <div className={cn('space-y-1.5', className)}>
      <label
        htmlFor={htmlFor}
        className="text-xs font-medium text-textDim uppercase tracking-wider"
      >
        {label}
      </label>
      {children}
      {error
        ? <p className="text-xs text-rose">{error}</p>
        : hint
        ? <p className="text-xs text-textFaint">{hint}</p>
        : null}
    </div>
  )
}
